import angular from 'angular';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.page.order.detail", [
    "merchant.application.module.order.header",
    "merchant.application.module.order.productSummary",
    "merchant.application.module.order.total",
    "merchant.application.module.order.delivery",
    "merchant.application.module.order.settlementSummary",
    "merchant.application.module.order.settlementHistoryList",
    "merchant.application.module.order.inStoreCard",
    "merchant.application.module.map",
    "merchant.application.module.order.cashAppPay",
]).controller("merchant.application.page.order.detail.controller", [
    "$rootScope", "$scope", "$controller",
    "$routeParams",
    "merchant.application.main.factory.orderTransaction",
    "merchant.application.main.factory.authentication",
    function($rootScope, $scope, $controller, $routeParams, OrderTransaction, Authentication) {
        $controller("merchant.application.page.controller", {$scope: $scope});

        if ($routeParams.orderId) {
            $scope.model.orderId = $routeParams.orderId;
        }

        $scope.populate = function() {
            if (! $scope.model.populating && $scope.model.orderId) {
                $scope.model.populating = true;
                OrderTransaction.populate({
                    merchantId: Authentication.merchantId(),
                    orderId: $scope.model.orderId
                }, function(data) {
                    OrderTransaction.repopulateOrderForScope($scope, data);
                    $scope.model.populating = false;
                }, function() {
                    $scope.model.populating = false;
                });
            }
        };

        $scope.populate();

        $scope.settlementDateVisible = function() {
            return $scope.model.order.source != "VIRTUAL_CARD_ONLINE"
        }

        $scope.isInStoreCardChannel = function() {
            return $scope.model.order.channel === "IN_STORE_CARD" || $scope.model.order.channel === "IN_STORE_CARD_ONLINE";
        }

        $scope.isCashAppPay = function() {
            return $scope.model.order?.channel === "CASH_APP";
        }

        $rootScope.$on("authVoided", function(event, voidedOrder) {
            if (voidedOrder) {
                OrderTransaction.repopulateOrderForScope($scope, voidedOrder);
            } else {
                $scope.populate();
            }
        });

        $rootScope.$on("refundedOrder", function(event, refundedOrder) {
           if (refundedOrder) {
               OrderTransaction.repopulateOrderForScope($scope, refundedOrder);
           } else {
               $scope.populate();
           }
        });
    }
]);
